@let color = config.color;
<div class="tooltip {{ color }} {{ config.textAlign }}">
  @if (config.showArrow) {
    @let arrowPosition = config.arrowPosition$ | async;
    <span
      class="arrow {{ color }}"
      [style.bottom.px]="arrowPosition?.y"
      [style.left.px]="arrowPosition?.x"
    ></span>
  }

  <div class="content" [class.onyx-on-inverse]="color === 'black'">
    @let context = config.context;
    @if (isString(context)) {
      <span
        [class]="color === 'white' ? 'f-body-l f-medium' : 'f-body-m f-medium'"
        [innerHTML]="context | translate"
      ></span>
    } @else if (isTemplateRef(context)) {
      <ng-template
        [ngTemplateOutlet]="context"
        [ngTemplateOutletContext]="config.templateContext ?? null"
      ></ng-template>
    } @else {
      <ng-container
        *ngComponentOutlet="context.ref; inputs: context.inputs"
      ></ng-container>
    }
  </div>
</div>
